/** Max columns for numeric cell key encoding. row * MAX_COLS + col */
const MAX_COLS = 256;

/** Encode (row, col) into a single numeric key for Map/Set lookups. */
export function cellKey(row: number, col: number): number {
  return row * MAX_COLS + col;
}

export type CellStack = number[];

export interface GridPosition {
  row: number;
  col: number;
}

export interface MegaBlock {
  id: number;
  colorIndex: number;
  hp: number;
  maxHp: number;
  row: number;
  col: number;
  width: number;
  height: number;
}

export interface MegaBlockDef {
  row: number;
  col: number;
  width: number;
  height: number;
  colorIndex: number;
  hp: number;
}

export interface LockedDoor {
  id: number;
  colorIndex: number;
  hp: number;
  maxHp: number;
  row: number;
  col: number;
  width: number;
  height: number;
}

export interface LockedDoorDef {
  row: number;
  col: number;
  width: number;
  height: number;
  hp: number;
  colorIndex?: number;
}

export interface BlockadeWall {
  id: number;
  side: 'top' | 'bottom' | 'left' | 'right';
  colorIndex: number;
  hp: number;
  maxHp: number;
  startCell: number;
  length: number;
}

export interface BlockadeWallDef {
  side: 'top' | 'bottom' | 'left' | 'right';
  colorIndex?: number;
  hp: number;
  startCell: number;
  length: number;
}

export interface BarricadeDef {
  row: number;
  col: number;
  width: number;
  height: number;
  hp: number;
}

export interface Barricade {
  id: number;
  hp: number;
  maxHp: number;
  row: number;
  col: number;
  width: number;
  height: number;
}
